import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M4 0C1.79102 0 0 1.79166 0 4C0 6.20963 1.79102 8 4 8C6.20898 8 8 6.20963 8 4C8 1.79166 6.20898 0 4 0ZM4 1.77419C4.37413 1.77419 4.67742 2.07748 4.67742 2.45161C4.67742 2.82574 4.37413 3.12903 4 3.12903C3.62587 3.12903 3.32258 2.82574 3.32258 2.45161C3.32258 2.07748 3.62587 1.77419 4 1.77419ZM4.90323 5.87097C4.90323 5.97785 4.81656 6.06452 4.70968 6.06452H3.29032C3.18344 6.06452 3.09677 5.97785 3.09677 5.87097V5.48387C3.09677 5.37698 3.18344 5.29032 3.29032 5.29032H3.48387V4.25806H3.29032C3.18344 4.25806 3.09677 4.1714 3.09677 4.06452V3.67742C3.09677 3.57053 3.18344 3.48387 3.29032 3.48387H4.32258C4.42947 3.48387 4.51613 3.57053 4.51613 3.67742V5.29032H4.70968C4.81656 5.29032 4.90323 5.37698 4.90323 5.48387V5.87097Z"
      fill={props?.fill || '#070F21'}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const InfoIcon = memo(ForwardRef);
export default InfoIcon;
